<template lang="html">

  <div class="wrapper -home">

    <section class="intro column-center" :style="`background:url(${$t('Imagen intro home')}) center/cover no-repeat`">
      <h1 class="big-title column-center">
        <span>{{$t('Titulo home')}}</span>
      </h1>
    </section>

    <section class="categorias-home column-center">

      <h1 v-html="$t('Intro actividades')"></h1>

    </section>

    <banner-calendario></banner-calendario>

    <section class="categorias-home" :par="categorias.filter(e => e.featured == 1).length != 1" v-if="categorias.filter(c => c.visible == 1).length > 0">

      <h2 class="big-title">
        <strong>{{$t('A Jaén')}}</strong>
      </h2>

      <div class="categorias container row-between">

        <article class="categoria-square -castillos-y-batallas column-between"
          :style="`background:url(${categoria.banner.url}) center/cover no-repeat`" v-for="(categoria, key) in categorias" v-if="categoria.featured == 1 && !categoria.mother_id">
          <div class="contenedor-imagen">
            <img v-if="categoria.logo.url" :src="categoria.logo.url" alt="Logo">
          </div>
          <a class="btn-skull">Ver actividades</a>
          <router-link :to="$t('enlaces.categoria')+'/'+categoria.slug" class="enlace-cover">
            Ir
          </router-link>
        </article>
   
      </div>
    </section>


    <section id="como-inscribirte" class="como-inscribirte column-center" v-if="categorias.filter(c => c.visible == 1).length > 0">
      <h2 class="subtitle">{{$t('Como inscribirse')}}</h2>

      <div class="tips-inscripcion row-center container ais">
        <article>
          <div class="contenedor-imagen">
            <img :src="$t('Imagen inscribirse 1')" alt="Reserva">
          </div>
          <div class="contenedor-texto">
            <h3>{{$t('Titulo inscribirse 1')}}</h3>
            <div v-html="$t('Cuerpo inscribirse 1')"></div>
          </div>
        </article>
        <article>
          <div class="contenedor-imagen">
            <img :src="$t('Imagen inscribirse 2')" alt="Inscríbete">
          </div>
          <div class="contenedor-texto">
            <h3>{{$t('Titulo inscribirse 2')}}</h3>
            <div v-html="$t('Cuerpo inscribirse 2')"></div>
          </div>
        </article>
        <article>
          <div class="contenedor-imagen">
            <img :src="$t('Imagen inscribirse 3')" alt="Cuando inscribirte">
          </div>
          <div class="contenedor-texto">
            <h3>{{$t('Titulo inscribirse 3')}}</h3>
            <div v-html="$t('Cuerpo inscribirse 3')"></div>
          </div>
        </article>
      </div>


    </section>

    <!-- <ig></ig> -->
  </div>

</template>

<script lang="js">

  import ig from '@/components/parts/IG-integration';

  import bannercalendario from '@/components/parts/banner-buscador-calendario';

  import { mapGetters } from 'vuex';

  export default {
    name: 'home',
    components: {
      'ig': ig,
      'banner-calendario': bannercalendario
    },
    computed: {
      ...mapGetters({
        categorias: 'getCategorias'
      })
    },
  }

</script>


<style lang="scss">
    h1 {
		color: #69770D;
		font-size: 46px;
		line-height: 46px;

		strong {
			font-family: 'Muli', sans-serif;
			font-weight: 900;
			width: 100%;
			display: inline-block;
			text-transform: uppercase;
			font-size: 50px;
			margin-bottom: 10px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/views/home.vue